// Messages for operator/settings/DataCleanup (auto-merged into the i18n catalog).
export const en = {
  'operator.data_cleanup.head': 'Data cleanup — Operator',
  'operator.data_cleanup.title': 'Data cleanup',
  'operator.data_cleanup.description':
    'Find near-duplicate records from the migration and merge them onto one canonical row. Every merge is reversible.',
  'operator.data_cleanup.similarity': 'Match strictness',
  'operator.data_cleanup.loose': 'Loose',
  'operator.data_cleanup.balanced': 'Balanced',
  'operator.data_cleanup.strict': 'Strict',
  'operator.data_cleanup.clusters_title': 'Suggested duplicates',
  'operator.data_cleanup.clusters_empty': 'No likely duplicates found at this strictness.',
  'operator.data_cleanup.records_count': '{count} records',
  'operator.data_cleanup.usage': '{count} uses',
  'operator.data_cleanup.review': 'Review & merge',
  'operator.data_cleanup.merge_title': 'Merge duplicates',
  'operator.data_cleanup.pick_canonical': 'Pick the record to keep — the others merge into it.',
  'operator.data_cleanup.keep': 'Keep',
  'operator.data_cleanup.preview_title': 'This merge will re-point',
  'operator.data_cleanup.repoint_row': '{count} {table}',
  'operator.data_cleanup.conflicts': '{count} duplicate link(s) will be de-duplicated',
  'operator.data_cleanup.no_changes': 'Nothing references the merged records.',
  'operator.data_cleanup.calculating': 'Calculating…',
  'operator.data_cleanup.confirm': 'Merge records',
  'operator.data_cleanup.cancel': 'Cancel',
  'operator.data_cleanup.history_title': 'Recent cleanups',
  'operator.data_cleanup.history_empty': 'No cleanups yet.',
  'operator.data_cleanup.undo': 'Undo',
  'operator.data_cleanup.reversed': 'Reversed',
  'operator.data_cleanup.by': 'by {name}',
  // Free-text normalize (consignee names)
  'operator.data_cleanup.normalize_title': 'Normalize spellings',
  'operator.data_cleanup.normalize_button': 'Normalize',
  'operator.data_cleanup.canonical_label': 'Canonical value',
  'operator.data_cleanup.normalize_intro':
    'These spellings will all be rewritten to the canonical value.',
  'operator.data_cleanup.normalize_confirm': 'Apply',
  // Manual "search & pick" merge builder
  'operator.data_cleanup.manual_merge': 'Manual merge',
  'operator.data_cleanup.manual_intro':
    'Search and pick the records to merge, then choose the one to keep. Use this for duplicates the suggestions miss.',
  'operator.data_cleanup.manual_sources': 'Records to merge',
  'operator.data_cleanup.manual_target': 'Merge into (keep)',
  'operator.data_cleanup.search_placeholder': 'Search…',
  'operator.data_cleanup.no_results': 'No matches.',
  'operator.data_cleanup.selected_count': '{count} selected',
}

export const zhTW = {
  'operator.data_cleanup.head': '資料清理 — 操作員',
  'operator.data_cleanup.title': '資料清理',
  'operator.data_cleanup.description':
    '找出移轉產生的相近重複記錄，將它們合併到單一標準記錄。每次合併皆可還原。',
  'operator.data_cleanup.similarity': '比對嚴格度',
  'operator.data_cleanup.loose': '寬鬆',
  'operator.data_cleanup.balanced': '平衡',
  'operator.data_cleanup.strict': '嚴格',
  'operator.data_cleanup.clusters_title': '建議的重複項',
  'operator.data_cleanup.clusters_empty': '在此嚴格度下未找到可能的重複項。',
  'operator.data_cleanup.records_count': '{count} 筆記錄',
  'operator.data_cleanup.usage': '{count} 次引用',
  'operator.data_cleanup.review': '檢視並合併',
  'operator.data_cleanup.merge_title': '合併重複項',
  'operator.data_cleanup.pick_canonical': '選擇要保留的記錄，其餘將合併至此。',
  'operator.data_cleanup.keep': '保留',
  'operator.data_cleanup.preview_title': '此合併將重新指向',
  'operator.data_cleanup.repoint_row': '{count} 筆 {table}',
  'operator.data_cleanup.conflicts': '{count} 筆重複關聯將被去除',
  'operator.data_cleanup.no_changes': '沒有記錄引用被合併的項目。',
  'operator.data_cleanup.calculating': '計算中…',
  'operator.data_cleanup.confirm': '合併記錄',
  'operator.data_cleanup.cancel': '取消',
  'operator.data_cleanup.history_title': '近期清理',
  'operator.data_cleanup.history_empty': '尚無清理記錄。',
  'operator.data_cleanup.undo': '還原',
  'operator.data_cleanup.reversed': '已還原',
  'operator.data_cleanup.by': '由 {name}',
  'operator.data_cleanup.normalize_title': '標準化拼寫',
  'operator.data_cleanup.normalize_button': '標準化',
  'operator.data_cleanup.canonical_label': '標準值',
  'operator.data_cleanup.normalize_intro': '這些拼寫都會改寫為標準值。',
  'operator.data_cleanup.normalize_confirm': '套用',
  'operator.data_cleanup.manual_merge': '手動合併',
  'operator.data_cleanup.manual_intro':
    '搜尋並選取要合併的記錄，再選擇要保留的一筆。適用於建議未涵蓋的重複項。',
  'operator.data_cleanup.manual_sources': '要合併的記錄',
  'operator.data_cleanup.manual_target': '合併至（保留）',
  'operator.data_cleanup.search_placeholder': '搜尋…',
  'operator.data_cleanup.no_results': '沒有相符項目。',
  'operator.data_cleanup.selected_count': '已選取 {count} 筆',
}
